<template>
  <div>
    <Loading v-if="actionLoading" :text="loadingText"></Loading>
    <van-search
      autocomplete="off"
      v-model="queryParams.orderNo"
      @search="onSearch"
      placeholder="请输入订单号进行查询"
    >
      <template #right-icon>
        <van-icon name="filter-o" @click="openFilter" />
      </template>
    </van-search>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      @load="getList(true)"
    >
      <div
        v-for="item in tableData"
        :key="item.afterSaleId"
        class="sale-card"
        @click="goDetail(item)"
      >
        <!-- 标题行：售后单号、服务类型、售后状态 -->
        <div class="card-row top">
          <span
            ><span class="sale-no">{{ item.afterSaleNo || "-" }}</span>
            <van-tag plain type="primary">{{
              getTypeText(item.afterSaleType)
            }}</van-tag>
          </span>

          <van-tag :type="getStatusType(item.status)">{{
            getStatusText(item.status)
          }}</van-tag>
        </div>
        <!-- 内容块：右侧箭头 + 底部操作按钮 -->
        <div class="content-body">
          <div class="content-left">
            <div class="card-row">
              <span class="label">订单号</span>
              <span class="value">{{ item.orderNo || "-" }}</span>
            </div>
            <div class="card-row">
              <span class="label">申请时间</span>
              <span class="value">{{ item.applyTime || "-" }}</span>
            </div>
            <div class="card-row">
              <span class="label">退款金额</span>
              <span class="value amount">{{
                item.refundAmount != null ? "￥" + item.refundAmount : "-"
              }}</span>
            </div>
            <div class="card-row">
              <span class="label">创客id</span>
              <span class="value">{{ getMerchText(item) }}</span>
            </div>
            <div class="card-row">
              <span class="label">申请原因</span>
              <span class="value">{{ item.reason || "-" }}</span>
            </div>
          </div>
          <van-icon class="arrow" name="arrow" />
        </div>
        <!-- 底部操作按钮 -->
        <div class="actions" @click.stop>
          <template v-if="item.status === 100">
            <van-button
              size="small"
              type="primary"
              block
              @click="handlePass(item)"
              >通过</van-button
            >
            <van-button size="small" block @click="handleReject(item)"
              >拒绝</van-button
            >
          </template>
          <van-button
            v-else-if="item.status === 500"
            size="small"
            type="warning"
            block
            @click="handleRefund(item)"
            >打款</van-button
          >
        </div>
      </div>
    </van-list>

    <!-- 筛选弹窗 -->
    <van-popup
      v-model:show="filterVisible"
      position="top"
      :style="{ height: '45%' }"
    >
      <div class="filter-content">
        <div class="filter-title">筛选条件</div>
        <div class="filter-item">
          <div class="filter-label">申请时间</div>
          <QuickDatePicker
            :start-time.sync="filterForm.applyTimeStart"
            :end-time.sync="filterForm.applyTimeEnd"
            defaultType="today"
          />
        </div>
        <div class="filter-item">
          <div class="filter-label">售后状态</div>
          <div class="filter-options">
            <span
              v-for="option in statusOptions"
              :key="option.value"
              :class="{ active: filterForm.status === option.value }"
              @click="selectStatus(option.value)"
            >
              {{ option.label }}
            </span>
          </div>
        </div>
        <div class="filter-actions">
          <van-button size="small" @click="resetFilter">重置</van-button>
          <van-button size="small" type="primary" @click="confirmFilter">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>

    <!-- 拒绝原因弹窗 -->
    <van-popup
      v-model:show="rejectVisible"
      position="bottom"
      round
      close-on-click-overlay
    >
      <div class="reject-content">
        <div class="reject-title">审核拒绝</div>
        <van-field
          v-model="rejectRemark"
          type="textarea"
          rows="3"
          maxlength="200"
          show-word-limit
          placeholder="请输入拒绝原因"
        />
        <div class="reject-actions">
          <van-button block @click="rejectVisible = false">取消</van-button>
          <van-button
            block
            type="danger"
            :loading="actionLoading"
            @click="confirmReject"
            >确定拒绝</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  queryList,
  auditPass,
  auditReject,
  refund,
} from "@/service/api/retail/afterSale";
import QuickDatePicker from "@/components/quickDatePicker";
import { Dialog, Toast } from "vant";
import { debounce } from "lodash";
import Loading from "@/components/loading.vue";

export default {
  name: "RetailAfterSale",
  components: { QuickDatePicker, Loading },
  data() {
    return {
      loadingText: "加载中...",
      loading: false,
      finished: false,
      actionLoading: false,
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
      queryParams: {
        orderNo: "",
      },
      filterVisible: false,
      filterForm: {
        applyTimeStart: "",
        applyTimeEnd: "",
        afterSaleType: null,
        status: null,
      },
      // 拒绝原因弹窗
      rejectVisible: false,
      rejectRemark: "",
      rejectItem: null,
      // 售后类型：0-仅退款 1-退货退款 2-换货
      typeOptions: [
        { label: "仅退款", value: 0 },
        { label: "退货退款", value: 1 },
        { label: "换货", value: 2 },
      ],
      // 售后状态
      statusOptions: [
        { label: "待审核", value: 100 },
        { label: "已拒绝", value: 200 },
        { label: "待退货", value: 300 },
        { label: "已退货", value: 400 },
        { label: "待退款", value: 500 },
        { label: "部分退款", value: 550 },
        { label: "已退款", value: 600 },
        { label: "已取消", value: 700 },
        { label: "售后完成", value: 800 },
      ],
    };
  },
  created() {
    // 输入防抖：停止输入 500ms 后触发查询
    this.debouncedSearch = debounce(() => {
      this.onSubmit();
    }, 500);
  },
  mounted() {
    this.onSubmit();
  },
  beforeDestroy() {
    this.debouncedSearch.cancel();
  },
  watch: {
    "queryParams.orderNo"() {
      this.debouncedSearch();
    },
  },
  methods: {
    // 回车/点击搜索按钮：取消防抖立即查询
    onSearch() {
      this.debouncedSearch.cancel();
      this.onSubmit();
    },
    openFilter() {
      this.filterVisible = true;
    },
    // 售后类型单选，再次点击取消
    selectType(value) {
      this.filterForm.afterSaleType =
        this.filterForm.afterSaleType === value ? null : value;
    },
    // 售后状态单选，再次点击取消
    selectStatus(value) {
      this.filterForm.status = this.filterForm.status === value ? null : value;
    },
    resetFilter() {
      this.filterForm.applyTimeStart = "";
      this.filterForm.applyTimeEnd = "";
      this.filterForm.afterSaleType = null;
      this.filterForm.status = null;
    },
    confirmFilter() {
      this.filterVisible = false;
      this.onSubmit();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.tableData = [];
      this.finished = false;
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        orderNo: this.queryParams.orderNo || undefined,
        applyTimeStart: this.filterForm.applyTimeStart
          ? this.filterForm.applyTimeStart + " 00:00:00"
          : undefined,
        applyTimeEnd: this.filterForm.applyTimeEnd
          ? this.filterForm.applyTimeEnd + " 23:59:59"
          : undefined,
        afterSaleType:
          this.filterForm.afterSaleType === null
            ? undefined
            : this.filterForm.afterSaleType,
        status:
          this.filterForm.status === null ? undefined : this.filterForm.status,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      queryList(params)
        .then((res) => {
          this.tableData = load
            ? this.tableData.concat(res.data.datas || [])
            : res.data.datas || [];
          this.loading = false;
          this.totalCount = res.data.totalCount || 0;
          this.totalPage = res.data.totalPage || 1;
          if (this.pageIndex >= this.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        });
    },
    getTypeText(type) {
      const opt = this.typeOptions.find((t) => t.value === type);
      return opt ? opt.label : "-";
    },
    getStatusText(status) {
      const opt = this.statusOptions.find((s) => s.value === status);
      return opt ? opt.label : "-";
    },
    getStatusType(status) {
      // 100待审核-红 500待退款-橙 800完成-绿 700取消-灰 其余蓝
      if (status === 800 || status === 600) return "success";
      if (status === 100 || status === 200) return "danger";
      if (status === 300 || status === 400 || status === 500 || status === 550)
        return "warning";
      return "primary";
    },
    // 创客id（手机号）：手机号字段后端可能不返回，做兜底展示
    getMerchText(item) {
      if (item.buyerId && item.phone) {
        return `${item.buyerId}（手机号${item.phone}）`;
      }
      return item.buyerId || "-";
    },
    goDetail(item) {
      this.$router.push(`/retail/afterSaleDetail/${item.afterSaleId}`);
    },
    // 审核通过
    handlePass(item) {
      Dialog.confirm({
        title: "确认弹窗",
        message: "确认审核通过该售后申请？",
      })
        .then(() => {
          this.actionLoading = true;
          auditPass({ afterSaleId: item.afterSaleId })
            .then((res) => {
              Toast.success(res.msg || "审核通过成功");
              this.onSubmit();
            })
            .finally(() => {
              this.actionLoading = false;
            });
        })
        .catch(() => {});
    },
    // 审核拒绝：打开原因弹窗
    handleReject(item) {
      this.rejectItem = item;
      this.rejectRemark = "";
      this.rejectVisible = true;
    },
    confirmReject() {
      if (!this.rejectRemark.trim()) {
        Toast.fail("请输入拒绝原因");
        return;
      }
      this.actionLoading = true;
      auditReject({
        afterSaleId: this.rejectItem.afterSaleId,
        auditRemark: this.rejectRemark,
      })
        .then((res) => {
          Toast.success(res.msg || "已拒绝");
          this.rejectVisible = false;
          this.onSubmit();
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },
    // 打款/退款
    handleRefund(item) {
      Dialog.confirm({
        title: "确认弹窗",
        message: "确认进行打款/退款操作？",
      })
        .then(() => {
          this.actionLoading = true;
          this.loadingText = "正在打款";
          refund({ afterSaleId: item.afterSaleId })
            .then((res) => {
              Toast.success(res.msg || "打款成功");
              this.onSubmit();
            })
            .finally(() => {
              this.actionLoading = false;
              this.loadingText = "";
            });
        })
        .catch(() => {
          this.actionLoading = false;
          this.loadingText = "";
        });
    },
  },
};
</script>
<style lang="less" scoped>
.sale-card {
  position: relative;
  background: #fff;
  margin: 8px 10px;
  padding: 10px 12px;
  border-radius: 8px;

  .card-row {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #666;
    justify-content: space-between;

    & + .card-row {
      margin-top: 8px;
    }

    .label {
      color: #999;
      min-width: 5rem;
    }

    .value {
      color: #333;
      text-align: right;
      flex: 1;
      word-break: break-all;
    }

    &.top {
      justify-content: space-between;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 6px;
      .sale-no {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 8px;
      }
    }

    .amount {
      color: #ee0a24;
      font-weight: 600;
    }
  }

  .content-body {
    display: flex;
    align-items: center;
    margin-top: 8px;

    .content-left {
      flex: 1;
    }

    .arrow {
      color: #c8c9cc;
      font-size: 16px;
      margin-left: 8px;
      flex-shrink: 0;
    }
  }

  .actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f4f4f4;
  }
}

.filter-content {
  padding: 15px;

  .filter-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .filter-item {
    margin-bottom: 15px;

    .filter-label {
      font-size: 14px;
      margin-bottom: 8px;
      color: #333;
    }

    .filter-options {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;

      span {
        padding: 4px 12px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;

        &.active {
          background-color: #1989fa;
          color: #fff;
          border-color: #1989fa;
        }
      }
    }
  }

  .filter-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
  }
}

.reject-content {
  padding: 15px;

  .reject-title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 12px;
  }

  .reject-actions {
    display: flex;
    gap: 10px;
    margin-top: 15px;
  }
}
</style>
